<script>
export const group = 'Full'
</script>

<script setup>
import { cdnImageUrl } from '@dpgradio/creative'
import JOEBackground4 from '../../../assets/animations/joe/backgrounds/joe_background_4.webm'
import Transition4 from './transitions/Transition4.vue'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
import SlidingPill from './elements/SlidingPill.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const track = computed(() => item.enrichment?.track?.next)
const activeEdition = computed(() => track.value.activeEditions?.[0])

const timelineSuperTitle = ref(null)
const timelineSuperTitleOut = ref(null)
const timelineTitle = ref(null)
const timelineTitleOut = ref(null)
const timelineArtist = ref(null)
const timelineArtistOut = ref(null)
const timelinePill = ref(null)
const timelinePillOut = ref(null)

const imageElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'NextPlaying', delay: frames(40, 50) })
    .from(imageElement, { scale: 0, duration: frames(46, 50), ease: 'back.out(1.7)' })
    .add(timelineSuperTitle)
    .add(timelineTitle, `<${frames(8, 50)}`)
    .add(timelineArtist, `<${frames(12, 50)}`)
    .add(timelinePill, `<${frames(16, 50)}`)
})
</script>

<template>
  <Transition4>
    <div class="size-full bg-joe-cr-blue-primary">
      <VideoPlayer :src="JOEBackground4" class="absolute size-full object-cover" autoplay muted />

      <img v-if="track.thumbnail" ref="imageElement" :src="cdnImageUrl(track.thumbnail)" class="absolute top-[344px] right-[370px] size-96 rounded-full object-cover drop-shadow-lg" />

      <div class="absolute right-[948px] top-[344px] h-96 flex flex-col justify-center items-end text-white pl-24 text-right">
        <TextSlideUpFade text="Straks op JOE" class="text-5xl mb-8" @timeline="timelineSuperTitle = $event" @timelineOut="timelineSuperTitleOut = $event" />
        <TextSlideUpFade :text="track.title" class="text-8xl font-bold mb-3" @timeline="timelineTitle = $event" @timelineOut="timelineTitleOut = $event" />
        <TextSlideUpFade :text="track.artist.name" class="text-6xl" @timeline="timelineArtist = $event" @timelineOut="timelineArtistOut = $event" />

        <SlidingPill
          v-if="activeEdition"
          :text="`${activeEdition.list.name} - #${activeEdition.position}`"
          class="text-4xl !h-12 mt-12"
          @timeline="timelinePill = $event"
          @timelineOut="timelinePillOut = $event"
        />
        <div v-else class="h-12 mt-12" />
      </div>
    </div>
  </Transition4>
</template>
